import { useCallback, useState } from "react";
import {
  Product,
  ProductAttribute,
  ProductVariation,
  ProductVariationAttribute,
} from "../contexts/products";
import { renderPrice } from "../utils/price";
import { Button } from "./Button";

import { CartItem, CartItemType, useHeyFlowLeadContext } from "../contexts/heyFlowLead";
import { useLocation, useNavigate } from "react-router-dom";
import { usePopupsContext } from "../contexts/popups";
import { Headline } from "./Headline";
import { Spinner } from "./Spinner";
import { TCremation } from "../utils/api";

export interface ProductDetailsProps {
  product: Product;
  productVariation: ProductVariation[];
  preSelectedVariationId?: number | undefined;
  isCartItem?: boolean;
  addItem: (item: CartItem, goBackToPurchase: boolean) => void;
}

export interface CremationProductDetailsProps {
  eizen: {
    product: Product,
    variation: ProductVariation[],
  }
  sammeln: {
    product: Product,
    variation: ProductVariation[],
  },
  premium: {
    product: Product,
    variation: ProductVariation[],
  }
  preSelectedVariationId?: number | undefined;
  preselectedProductId?: number | undefined;
  isCartItem?: boolean;
  addItem: (item: CartItem, goBackToPurchase: boolean, weight: string, cremation: TCremation) => void;
}
function hasVariations(availableVariations: ProductVariation[], selection: Record<number, string>) {
  return availableVariations.some((variation) => {
    return variation.attributes.every((attribute) => {
      return selection[attribute.id] === undefined || selection[attribute.id] === attribute.option;
    });
  });
}

function variationsForSelection(availableVariations: ProductVariation[], selection: Record<number, string>) {
  return availableVariations.filter((variation) => {
    return variation.attributes.every((attribute) => {
      return selection[attribute.id] === undefined || selection[attribute.id] === attribute.option;
    });
  });
}



export function CremationProductDetails(props: CremationProductDetailsProps) {
  const { value, standardProductDefinitions } = useHeyFlowLeadContext();
  const navigate = useNavigate();
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const goBackToPurchase = urlParams.get("back") === "purchase";

  const { setPopupType } = usePopupsContext();

  const [cremationType, setCremationType] = useState<"Sammelkremierung" | "Premiumkremierung"| "Einzelkremierung" | undefined >(props.preselectedProductId === 65854 ? 'Premiumkremierung' : props.preselectedProductId === 27448 ? 'Sammelkremierung' : props.preselectedProductId === 24936 ? 'Einzelkremierung' : undefined);

  console.log("Attributes");
  console.log("Selected product", props.preselectedProductId)

  const pickedProduct = cremationType === 'Premiumkremierung' ? props.premium : cremationType === 'Einzelkremierung' ? props.eizen : cremationType === 'Sammelkremierung' ? props.sammeln : props.eizen;
  if (!pickedProduct) {
    return (<Spinner size="small"></Spinner>);
  }
  const selectableAttributes = pickedProduct.product.attributes.filter((attribute) => attribute.variation);


  console.log("pickedProduct", pickedProduct);
  console.log("props.preSelectedVariationId", props.preSelectedVariationId);

  const [selectedAttributes, setSelectedAttributes] = useState<Record<number, string>>(() => {
    if (props.preSelectedVariationId !== undefined) {
      const variation = pickedProduct.variation.find((variation) => variation.id === props.preSelectedVariationId);
      if (variation !== undefined) {
        const selection: Record<number, string> = {};
        variation.attributes.forEach((attribute) => {
          console.log("attribute", attribute.id, " option ", attribute.option);
          //assign option like ,,bis 1 kg'' to selection at attribute.id, attribute.id is common across sammel/eizen
          selection[attribute.id] = attribute.option;
        });
        return selection;
      }
    }
    return {};
  });


  const setPopoverMessage = useCallback(
    (message: string) => {
      setPopupType({ type: "message", message });
    },
    [setPopupType]
  );


  const selectedVariations = variationsForSelection(pickedProduct.variation, selectedAttributes);

  //assign proper variationId to push it to cart
  const [uniqueSelectedVariation, variationAttributes] =
    selectedVariations.length === 1
      ? [selectedVariations[0], selectedVariations[0].attributes]
      : selectedVariations.length === 0
        ? [pickedProduct.product, undefined]
        : [undefined, undefined];

  const dimensions = uniqueSelectedVariation?.dimensions ?? pickedProduct.product.dimensions;
  const weight = uniqueSelectedVariation?.weight ?? pickedProduct.product.weight;
  const hasDimensions =
    Number(dimensions.length) !== 0 || Number(dimensions.height) !== 0 || Number(dimensions.width) !== 0;

  const colorAttribute = (
    uniqueSelectedVariation?.attributes as (ProductAttribute | ProductVariationAttribute)[]
  )?.find((attribute) => attribute.name === "Farbe");
  let color = (colorAttribute as ProductVariationAttribute)?.option ?? (colorAttribute as ProductAttribute)?.options[0];
  if (!color) {
    const productColors = pickedProduct.product.attributes.find((attribute) => attribute.name === "Farbe");
    if (productColors?.variation === false) {
      color = productColors.options[0];
    }
  }

  const details: [string, string | string[]][] = [];
  if (color) {
    //details.push(["Farbe", color]);
  }
  if (
    hasDimensions &&
    !pickedProduct.product.attributes.find((attribute) => attribute.variation === false && attribute.name === "Maße")
  ) {
    details.push(["Maße", `${dimensions.height} cm x ${dimensions.length} cm x ${dimensions.width} cm`]);
  }
  if (Number(weight) !== 0) {
    details.push(["Gewicht", `${weight} cm`]);
  }
  pickedProduct.product.attributes.forEach((attribute) => {
    if (attribute.variation === false) {
      if (
        attribute.name === "Verwendung" ||
        attribute.name === "Beschriftung" ||
        attribute.name === "Volumen" ||
        attribute.name === "Maße"
      ) {
        let value: string | string[] = attribute.options[0];
        if (attribute.name === "Volumen" || attribute.name === "Maße")
          value = value
            .split("Größe")
            .map((s, index) => (index > 0 ? `Größe${s}` : s))
            .filter((s, index) => index > 0 || s.trim().length > 0);
        details.push([attribute.name, value]);
      }
    }
  });

  if (!standardProductDefinitions) return null;
  const type = "cremation" as CartItemType;

  let buttonCaption;
  if (props.isCartItem === true) {

    if (
      //variation changed or product (cremation type) was changed
      (uniqueSelectedVariation !== undefined &&
        props.preSelectedVariationId !== undefined &&
        uniqueSelectedVariation.id !== props.preSelectedVariationId) ||
      cremationType !== value?.lead.lead.cremation.type
      
    ) {
      buttonCaption = "Auswählen";
    } else {
      buttonCaption = "Zurück";
    }
  } else {
    buttonCaption = "Produkt Auswählen";
  }

  return (
    <div className="bg-neutral-100 rounded-xl py-8 md:py-14 px-4 md:px-20 mt-10 text-sm sm:text-base">

      <Headline title={'Kremierungsart auswählen'} type="sub" className="mb-5" />
      {uniqueSelectedVariation === undefined ? (
        <div
          className="text-base md:text-lg font-medium"
          dangerouslySetInnerHTML={{ __html: pickedProduct.product.price_html }}
        ></div>
      ) : (
        <div className="text-base md:text-lg font-medium">
          {renderPrice(uniqueSelectedVariation.price, "EUR", true)}
        </div>
      )}
      <div className="">
        <div className="">
         <div className= "flex flex-row">
           <div
            className="lg:w-2/3 mt-8 text-sm lg:text-base mb-8"
            dangerouslySetInnerHTML={{ __html: pickedProduct.product.short_description }}
          ></div>
         </div>



          <div className="flex flex-row flex-wrap lg:flex-nowrap  "
          >


            <div className="w-full lg:w-1/2   mb-4 md:mb-1">

              <div className="mb-5" key={'s1'}>
                <div className="text-base md:text-lg mb-3 mt-10"> </div>

                <div
                  className={`cursor-pointer w-full py-2 border rounded-full text-base text-center mb-3 ${cremationType === 'Einzelkremierung'
                    ? "bg-neutral-600 text-white border-neutral-600"
                    : "bg-white border-neutral-500"
                    } 
                    }`}
                  key={'einzelkremierung'}
                  onClick={() => {
                    setCremationType('Einzelkremierung');
                  }}
                >
                  Einzelkremierung
                </div>



              </div>

              <div className="mb-5" key={'s19'}>
                <div className="text-base md:text-lg mb-3 mt-5"> </div>

                <div
                  className={`cursor-pointer w-full py-2 border rounded-full text-base text-center mb-3 ${cremationType === 'Sammelkremierung'
                    ? "bg-neutral-600 text-white border-neutral-600"
                    : "bg-white border-neutral-500"
                    } 
                    }`}
                  key={'sammelkremierung'}
                  onClick={() => {
                    setCremationType('Sammelkremierung');
                  }}
                >
                  Sammelkremierung
                </div>



              </div>


              <div className="mb-5" key={'s15'}>
                <div className="text-base md:text-lg mb-3 mt-5"> </div>

                <div
                  className={`cursor-pointer w-full py-2 border rounded-full text-base text-center mb-3 ${cremationType === 'Premiumkremierung'
                    ? "bg-neutral-600 text-white border-neutral-600"
                    : "bg-white border-neutral-500"
                    } 
                    }`}
                  key={'premiumkremierung'}
                  onClick={() => {
                    setCremationType('Premiumkremierung');
                  }}
                >
                  Premiumkremierung
                </div>



              </div>


            </div>


            <div className="lg:w-10"></div>

            <div className="w-full lg:w-1/2  mb-4 md:mb-1">
              {selectableAttributes.map((attribute) => (
                <div className="mb-5" key={attribute.id}>
                  <div className="text-base md:text-lg mb-3"> {attribute.name}</div>
                  {attribute.options
                    .filter((option) => hasVariations(pickedProduct.variation, { [attribute.id]: option }))
                    .map((option) => (
                      <div
                        className={`w-full py-2 border rounded-full text-base text-center mb-3 ${selectedAttributes[attribute.id] === option
                          ? "bg-neutral-600 text-white border-neutral-600"
                          : "bg-white border-neutral-500"
                          } ${hasVariations(pickedProduct.variation, { ...selectedAttributes, [attribute.id]: option })
                            ? "cursor-pointer"
                            : "text-neutral-300 border-neutral-300"
                          }`}
                        key={option}
                        onClick={() => {
                          console.log(attribute)
                          if (hasVariations(pickedProduct.variation, { ...selectedAttributes, [attribute.id]: option })) {
                            //we assign option like bis 10kg, attribute.id =  constant for this case, equal to 3.
                            setSelectedAttributes({ ...selectedAttributes, [attribute.id]: option });
                          } else {
                            setPopoverMessage("Diese Variante ist leider ausverkauft");
                          }
                        }}
                      >
                        {option}
                      </div>
                    ))}


                </div>
              ))}
            </div>




          </div>


          <div className=" md:py-3 max-md:bottom-0 max-md:fixed z-50 max-md:min-w-full max-md:left-0">
            <div className=" bg-neutral-100 py-3 px-7 lg:px-0">
              <Button
                caption={buttonCaption}
                fullWidth={true}
                large={false}
                inactive={uniqueSelectedVariation === undefined && props.isCartItem !== true}
                primary={true}
                onClick={() => {
                  console.log("Add to cart clicked");
                  if (props.isCartItem === true) {
                    if (
                      uniqueSelectedVariation === undefined ||
                      props.preSelectedVariationId === undefined ||
                      uniqueSelectedVariation.id === props.preSelectedVariationId
                    ) {
                      navigate(-1);
                      return;
                    }
                  }

                  if (!uniqueSelectedVariation) {
                    setPopoverMessage("Bitte wähle zuerst eine Variante aus");
                    return;
                  }
                  console.log("Adding to cart");
                  console.log(uniqueSelectedVariation)

                  props.addItem(
                    {
                      description: pickedProduct.product.short_description || pickedProduct.product.description,
                      image:
                        pickedProduct.product.images?.[0]?.src ??
                        "https://animaltree.de/wp-content/uploads/2022/01/Blaetter-Logo_high_res-1024x1024.png",
                      name:
                        type === "cremation"
                          ? `${pickedProduct.product.name}, Tiergewicht ${(uniqueSelectedVariation.attributes as ProductVariationAttribute[]).find(
                            ({ name }) => name === "Tiergewicht"
                          )?.option ?? ""
                          }`
                          : pickedProduct.product.name,
                      price: Math.round(Number(uniqueSelectedVariation.price) * 100) / 100,
                      productId: pickedProduct.product.id,
                      variationId:
                        uniqueSelectedVariation.id !== pickedProduct.product.id ? uniqueSelectedVariation.id : undefined,
                      variationAttributes,
                      type: type ?? "urn",
                      inscriptionIncluded: pickedProduct.product.tags?.some((tag) => tag.id === 1216) ?? false,
                    },
                    goBackToPurchase,
                    selectedAttributes[3],
                    {
                      type: cremationType!,
                      urn: value?.lead.lead?.cremation?.type != "Sammelkremierung" && cremationType !== 'Sammelkremierung' ? value!.lead.lead.cremation.urn : 'no urn'
                    },
                  );
                }}
              ></Button>
            </div>
          </div>
        </div>


      </div>

      {details.length > 0 && <Headline title="Details" type="sub" className="mb-3 mt-3 md:mt-20" />}
      {details.map((detail, index) => (
        <div key={index} className="md:flex mb-5 justify-between">
          <div className="shrink-0 grow-0 w-full md:w-3/12 font-semibold md:font-normal">{detail[0]}</div>

          <div className="shrink-0 grow-0 w-full md:w-8/12">
            {typeof detail[1] === "string" ? detail[1] : detail[1].map((d, index) => <div key={index}>{d}</div>)}
          </div>
        </div>
      ))}
     
    </div>
  );
}
